import { patchRequest } from '@/core';
import { locations } from '@/requests';

export default async function updateLocationRequest(data, id) {
	let url = locations.getByIdPath(id);
	let response = await patchRequest(url, {}, data);
	return response;
}
